<template>
  <div id="contenedor-eliminar-auditoria-informe-respuesta-detalle">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Detalle </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el Detalle? </span>
        <v-divider></v-divider>
        <div v-show="false"><v-spacer></v-spacer>
          <v-chip small
          :color="getColorStatus(observacionEstatus)" dark>{{observacionEstatus}}
            <v-icon right small
            v-if="observacionEstatus === 'SOLVENTADA'">
              mdi-check
            </v-icon>
          </v-chip>
        </div>
        <div style="display: inline-block;">
          <span>
            Observación:
          </span>
          <span class="font-weight-bold azul2--text">
            {{respuestaDetalle.observacionDetalle.auditoriaObservacion.numero}}
          </span>
        </div>
        <div style="display:block">
          <span class="text-caption font-weight-light"
          v-if="respuestaDetalle.observacionDetalle.auditoriaObservacion.descripcion">
            <cortar-texto
            :texto="respuestaDetalle.observacionDetalle.auditoriaObservacion ?
            respuestaDetalle.observacionDetalle.auditoriaObservacion.descripcion : ''"
            >
            </cortar-texto>
          </span>
        </div>
        <div style="display: inline-block;">
          <span>
            Contrato:
          </span>
          <!-- <span class="font-weight-bold naranja--text">
            {{respuestaDetalle.observacionDetalle?.contrato?.numero}}
          </span> -->
          <span
            v-if="respuestaDetalle.observacionDetalle.contrato"
            class="font-weight-bold naranja--text">
              {{respuestaDetalle.observacionDetalle.contrato.numero}}
          </span>
        </div>
        <div style="display:block">
          <span class="text-caption font-weight-light"
          v-if="respuestaDetalle.observacionDetalle">
            <cortar-texto
            :texto="respuestaDetalle.observacionDetalle ?
            respuestaDetalle.observacionDetalle.texto : ''"
            >
            </cortar-texto>
          </span>
        </div>
        <v-row>
          <v-switch color="success"
            disabled
            v-model="respuestaDetalle.esRespuestaParcial"
            label="Es Respuesta Parcial">
          </v-switch>
        </v-row>
        <v-row>
          <span class="text-caption font-weight-light base3--text"
          v-if="respuestaDetalle.comentarios">
            <cortar-texto
            :texto="respuestaDetalle.comentarios!='' && respuestaDetalle.comentarios!=null
            ? respuestaDetalle.comentarios : ''">
            </cortar-texto>
          </span>
        </v-row>
        <v-row>
          <h5>Documentos:</h5>
            <v-chip class="mx-2" small color="info">
              {{ respuestaDetalle.documentos.length }}
            </v-chip>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarAuditoriaInformeRespuestaDetalle"
          :disabled="enviandoFormulario || $apollo.loading || getEstatusSolventada()"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>

  <!-- Propuesta de actualización de Estatus de Observación -->
    <v-dialog
        v-if="!$apollo.loading && mostrarPropuestaActualizacionEstatus"
        v-model="mostrarPropuestaActualizacionEstatus"
        width="500px"
        persistent
        >
        <EvaluacionRespuestas
        v-on:cerrarVentanaEvaluacionRespuestas="cerrarVentanaEvaluacionRespuestas"
        v-on:botonActualizaEstatus="botonActualizaEstatus"
        :mensaje="getMensaje()"
        >
        </EvaluacionRespuestas>
    </v-dialog>
  </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import EvaluacionRespuestas from '@/components/administracion/auditorias/respuestas/detalles/EvaluacionRespuestas.vue';
import mixEvaluacionRespuestas from './mixEvaluacionRepuestas';
import mixRespuestas from '../mixRespuestas';

export default {
  name: 'EliminarAuditoriaInformeRespuestaDetalle',
  props: {
    respuestaDetalle: {
      type: Object,
      required: true,
    },
    respuesta: {
      type: Object,
      required: true,
    },
    informe: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixRespuestas, mixEvaluacionRespuestas],
  components: {
    CustomButton,
    CortarTexto,
    EvaluacionRespuestas,
  },
  data() {
    return {
      mostrarPropuestaActualizacionEstatus: false,
      enviandoFormulario: false,
      observacionEstatus: this.respuestaDetalle.observacionDetalle.auditoriaObservacion.estatus || '',
      actualizaEstatus: false,
      descripcionEstatusActualizar: '',
    };
  },
  methods: {
    async botonActualizaEstatus() {
      this.mostrarPropuestaActualizacionEstatus = !this.mostrarPropuestaActualizacionEstatus;
      await this.actualizarEstatusObservacion(
        [{
          idObservacion: this.respuestaDetalle.observacionDetalle.auditoriaObservacion.id,
        }],
        this.descripcionEstatusActualizar,
      );
      this.cerrar();
    },
    cerrarVentanaEvaluacionRespuestas() {
      this.mostrarPropuestaActualizacionEstatus = !this.mostrarPropuestaActualizacionEstatus;
      this.cerrar();
    },
    cerrar() {
      this.$emit('cerrar');
    },
    async botonEliminarAuditoriaInformeRespuestaDetalle() {
      await this.mixEliminarRespuestaDetalle();
      await this.mixEliminarDetalleDocumentos();
      if (this.getMensaje() !== '') {
        this.mostrarPropuestaActualizacionEstatus = true;
      } else {
        this.cerrar();
      }
    },
    getMensaje() {
      const detalleEvaluarRespuestas = (this.getEvaluarRespuestas()
        .filter((r) => r.idObservacion
        === this.respuestaDetalle.observacionDetalle.idAuditoriaObservacion))[0];
      const enviadas = detalleEvaluarRespuestas.enviadas.length;
      const noEnviadas = detalleEvaluarRespuestas.noEnviadas.length;
      const { estatus } = detalleEvaluarRespuestas;
      const { enviadasCompletas } = detalleEvaluarRespuestas;
      const { enviadasParciales } = detalleEvaluarRespuestas;

      if (estatus === 'RESPUESTA ENVIADA COMPLETA' && (noEnviadas > 0 || enviadasCompletas === false)) {
        this.descripcionEstatusActualizar = 'RESPUESTA ENVIADA PARCIAL';
        return `Quedan Desgloses de la observación por responder de manera
      completa al Ente, desea cambiar su estatus
      de RESPUESTA ENVIADA COMPLETA a RESPUESTA ENVIADA PARCIAL`;
      }
      if (estatus === 'RESPUESTA ENVIADA COMPLETA' && (enviadas === 0
      && enviadasCompletas === false
      && enviadasParciales === false)) {
        this.descripcionEstatusActualizar = 'PENDIENTE';
        return `Todos los deslgoses aun no han sido enviados al Ente,
        desea cambiar su estatus
      de RESPUESTA ENVIADA COMPLETA a PENDIENTE`;
      }
      if (estatus === 'RESPUESTA ENVIADA PARCIAL' && (enviadas === 0
      && enviadasCompletas === false
      && enviadasParciales === false)) {
        this.descripcionEstatusActualizar = 'PENDIENTE';
        return `Todos los deslgoses aun no han sido enviados al Ente,
        desea cambiar su estatus
      de RESPUESTA ENVIADA PARCIAL a PENDIENTE`;
      }
      return '';
    },
    getColorStatus(estatus) {
      switch (estatus) {
        case 'PENDIENTE':
          return 'red darken-1';
        case 'POR RESPONDER':
          return 'orange';
        case 'RESPUESTA ENVIADA PARCIAL':
          return 'info';
        case 'RESPUESTA ENVIADA COMPLETA':
          return 'success';
        case 'SOLVENTADA':
          return 'green darken-1';
        default:
          return 'warning';
      }
    },
    getEstatusSolventada() {
      if (!this.observacionEstatus || this.observacionEstatus === ''
      || this.observacionEstatus === 'SOLVENTADA') {
        return true;
      }
      return false;
    },
  },
};
</script>
